import util from '../util'

let base = window.$servicePath



export default {

    /**
     * 用户登录
     * @return
     */
    authenticate(name, password, forceLogin) {
        var s = window.localStorage.getItem("$customSessionId");
        if (forceLogin) {
            return util.ajax(`/authenticate`, { u: name, p: password, forceLogin: true, s: s })
        }
        return util.ajax(`/authenticate`, { u: name, p: password, s: s })
    },

    authenticateDev(name, password, forceLogin) {
        var s = window.localStorage.getItem("$customSessionId");
        if (forceLogin) {
            return util.ajax(`/authenticate`, { u: name, p: password, dev: true, forceLogin: true, s: s })
        }
        return util.ajax(`/authenticate`, { u: name, p: password, dev: true, s: s })
    },

    loginOut() {
        return util.ajax(`/logout`)
    },

    clearSession() {
        return util.ajax(`/clearSession`)
    },

    /**
     * 部门用户列表
     * @param departmentId  部门ID
     * @return
     */
    // listUser(departmentId) {
    //   return util.ajax(`${base}/api/org/listUser`, departmentId)
    // },

    listUser(params) {
        return util.ajax(`${base}/api/org/listUser`, params.departmentId)
    },

    /**
     * 以分页的方式查询用户
     * @param params
     * @param start 起始记录号，从0开始
     * @param limit 每次获取的最大记录数
     * @return 用户数据分页对象
     */
    listUserPaging(params) {
        return util.ajax(`${base}/api/org/listUserPaging`, params, params.start, params.limit)
    },

    /**
     * 以分页的方式查询组 权限分组
     * @param params
     * @param start 起始记录号，从0开始
     * @param limit 每次获取的最大记录数
     * @return 组数据分页对象
     */
    listGroupPagingByAuthType(params) {
        params.type = 'auth';
        return util.ajax(`${base}/api/org/listGroupPaging`, params, params.start, params.limit)
    },

    /**
     * 用户列表
     * @param ids
     * @return
     */
    getUsers(ids) {
        return util.ajax(`${base}/api/org/getUsers`, ids)
    },

    checkToken(ids) {
        return util.ajax(`${base}/api/org/checkToken`)
    },

    /**
     * 获取用户
     * @param id 用户Id
     * @return
     */
    getUser(id) {
        return util.ajax(`${base}/api/org/getUser`, id)
    },

    /**
     * 修改用户个人信息
     * @param data
     */
    updateUserInfo(params) {
        return util.ajax(`${base}/api/org/updateUserInfo`, params)
    },

    updateUserSession() {
        return util.ajax(`${base}/api/org/updateUserSession`)
    },

    updateUserSessionByDepartmentId(departmentId) {
        return util.ajax(`${base}/api/org/updateUserSessionByDepartmentId`, departmentId)
    },
    /**
     * 登陆用户信息
     * @returns {*}
     */
    loginUserInfo() {
        return util.ajax(`${base}/api/org/loginUserInfo`)
    },

    /**
     * 保存用户
     * @param data
     *   departmentId 部门ID
     * @return
     */
    saveUser(params) {
        return util.ajax(`${base}/api/org/saveUser`, params)
    },

    updateUserPassword(oldpassword, password) {
        return util.ajax(`${base}/api/org/updateUserPassword`, oldpassword, password)
    },


    /**
     * 删除用户
     * @param userIds 用户IDS
     * @return
     */
    deleteUser(userIds) {
        return util.ajax(`${base}/api/org/deleteUser`, userIds)
    },


    /**
     * 保存部门
     * @param data
     *   name  部门名称
     * @return
     */
    saveDepartment(params) {
        return util.ajax(`${base}/api/org/saveDepartment`, params)
    },

    /**
     * 转换部门用户
     * @param fromDepartmentId
     * @param toDepartmentId
     * @param userIds
     */
    changeDepartmentUser(fromDepartmentId, toDepartmentId, userIds) {
        return util.ajax(`${base}/api/org/changeDepartmentUser`, fromDepartmentId, toDepartmentId, userIds)
    },

    /**
     * 添加部门用户
     * @param departmentId
     * @param userIds
     */
    addDepartmentUser(departmentId, userIds) {
        return util.ajax(`${base}/api/org/addDepartmentUser`, departmentId, userIds)
    },

    /**
     * 部门列表
     * @param parentId  父部门
     * @return
     */
    listDepartment(parentId) {
        return util.ajax(`${base}/api/org/listDepartment`, parentId)
    },

    /**
     * 部门列表(过滤列表显示)
     * @param parentId  父部门
     * @return
     */
    listDepartmentListAble(parentId) {
        return util.ajax(`${base}/api/org/listDepartmentListAble`, parentId)
    },

    /**
     * 获取子部门列表
     * @param parentId  父部门
     * @param flags     部门类型
     * @returns {*}
     */
    listChildDepartment(params) {
        return util.ajax(`${base}/api/org/listChildDepartment`, params)
    },

    getUserDepartment(userId) {
        return util.ajax(`${base}/api/org/getUserDepartment`, userId)
    },

    /**
     * 获取部门
     * @param id
     */
    getDepartment(id) {
        return util.ajax(`${base}/api/org/getDepartment`, id)
    },

    /**
     * 删除部门
     * @param departmentIds 部门IDS
     * @return
     */
    deleteDepartment(departmentIds) {
        return util.ajax(`${base}/api/org/deleteDepartment`, departmentIds)
    },


    /**
     * 删除部门用户
     * @param departmentId 部门ID
     * @param userIds 需删除用户ID
     * @return
     */
    deleteDepartmentUser(departmentId, userIds) {
        return util.ajax(`${base}/api/org/deleteDepartmentUser`, departmentId, userIds)
    },

    /**
     * 删除部门管理员
     * @param departmentId 部门ID
     * @param userIds 需删除用户ID
     * @return
     */
    deleteDepartmentAdminUser(departmentId, userIds) {
        return util.ajax(`${base}/api/org/deleteDepartmentAdminUser`, departmentId, userIds)
    },

    /**
     * 添加部门管理员
     * @param departmentId 部门ID
     * @param userIds 需删除用户ID
     * @return
     */
    addDepartmentAdminUser(departmentId, userIds) {
        return util.ajax(`${base}/api/org/addDepartmentAdminUser`, departmentId, userIds)
    },



    /**
     * 删除租户管理员
     */
    deleteOwnerAdminUser(userId) {
        return util.ajax(`${base}/api/org/deleteOwnerAdminUser`, userId)
    },


    /**
     * 添加租户管理员
     */
    addOwnerAdminUser(userId) {
        return util.ajax(`${base}/api/org/addOwnerAdminUser`, userId)
    },


    /**
     * 删除系统管理员
     */
    deleteSystemAdminUser(userId) {
        return util.ajax(`${base}/api/org/deleteSystemAdminUser`, userId)
    },


    /**
     * 添加系统管理员
     */
    addSystemAdminUser(userId) {
        return util.ajax(`${base}/api/org/addSystemAdminUser`, userId)
    },

    /**
     * @param departmentId 部门ID
     * @param params       查询条件
     * @param start        起始记录行号，从0开始
     * @param limit        返回的最大记录数量
     * @return 部门分页对象
     */
    listDepartmentUserPaging(params) {
        return util.ajax(`${base}/api/org/listDepartmentUserPaging`, params.departmentId, params, params.start, params.limit)
    },

    listDepartmentAdminUser(params) {
        return util.ajax(`${base}/api/org/listDepartmentAdminUser`, params.departmentId, null)
    },

    /**
     * 角色列表
     */
    listRole(params) {
        return util.ajax(`${base}/api/org/listRole`, params)
    },

    /**
     * 保存权限
     */
    saveRole(params) {
        return util.ajax(`${base}/api/org/saveRole`, params)
    },

    getRoles(ids) {
        return util.ajax(`${base}/api/org/getRoles`, ids)
    },

    getRole(id) {
        return util.ajax(`${base}/api/org/getRole`, id)
    },

    getIdentity(id) {
        return util.ajax(`${base}/api/org/getIdentity`, id)
    },

    getRoleIdentity(id) {
        return util.ajax(`${base}/api/org/getRoleIdentity`, id)
    },

    listRoleIdentityIdsByRoleIds(ids) {
        return util.ajax(`${base}/api/org/listRoleIdentityIdsByRoleIds`, ids)
    },

    /**
     * 获取部门相关的身份对象
     * @param id   部门ID
     * @param type 身份对象类型: DEP_ROLE, DEP_USER
     * @param objId 角色或者用户ID
     * @return 身份对象
     */
    getDepartmentTypeIdentity(id, type, objId) {
        return util.ajax(`${base}/api/org/getDepartmentTypeIdentity`, id, type, objId)
    },

    listDepartmentAndCount(parentId) {
        return util.ajax(`${base}/api/org/listDepartmentAndCount`, parentId)
    },

    /**
     * 显示部门用户的所有角色
     * @param identityId 部门用户身份ID
     * @return
     */
    listDepartmentUserGroup(identityId) {
        return util.ajax(`${base}/api/org/listDepartmentUserGroup`, identityId)
    },

    /**
     * 显示部门用户的所有角色
     * @param identityId 部门用户身份ID
     * @return
     */
    listDepartmentUserRole(identityId) {
        return util.ajax(`${base}/api/org/listDepartmentUserRole`, identityId)
    },

    /**
     * 显示部门用户的所有角色
     * @param identityId 部门用户身份ID
     * @param type 权限类型，1为身份权限，2为文档权限，3为流程权限
     * @return
     */
    listDepartmentUserRoleByType(identityId, type) {
        return util.ajax(`${base}/api/org/listDepartmentUserRoleByType`, identityId, type)
    },

    /**
     * 新增部门用户的组
     * @param identityId 部门用户身份ID
     * @param groupIds 组IDS
     */
    addDepartmentUserGroup(identityId, groupIds) {
        return util.ajax(`${base}/api/org/addDepartmentUserGroup`, identityId, groupIds)
    },

    /**
     * 删除部门用户的组
     * @param identityId 部门用户身份IDs
     * @param groupIds 组IDS
     */
    deleteDepartmentUserGroup(identityId, groupIds) {
        return util.ajax(`${base}/api/org/deleteDepartmentUserGroup`, identityId, groupIds)
    },

    /**
     * 删除权限
     * @param ids
     */
    deleteRole(ids) {
        return util.ajax(`${base}/api/org/deleteRole`, ids)
    },
    /**
     * 删除权限
     * @param 分类ids
     */
    deleteRoleByCate(ids) {
        return util.ajax(`${base}/api/org/deleteRoleByCate`, ids)
    },

    /**
     * 列出权限
     * @param params
     * @return
     */
    listGroupedRole(params) {
        return util.ajax(`${base}/api/org/listGroupedRole`, params)
    },


    getGroups(ids) {
        return util.ajax(`${base}/api/org/getGroups`, ids)
    },

    getGroup(id) {
        return util.ajax(`${base}/api/org/getGroup`, id)
    },

    /**
     * 保存权限组
     */
    saveGroup(params) {
        params.type = 'auth';
        return util.ajax(`${base}/api/org/saveGroup`, params)
    },


    /**
     * 删除权组
     * @param ids
     */
    deleteGroup(ids) {
        return util.ajax(`${base}/api/org/deleteGroup`, ids)
    },

    /**
     * 删除权组
     * @param ids
     * isUnit 是否删除单位权限
     */
    deleteGroupByUnit(ids) {
        return util.ajax(`${base}/api/org/deleteGroupByUnit`, ids)
    },



    /**
     * 列出权限
     * @param params
     */
    listGroupedGroup(params) {
        return util.ajax(`${base}/api/org/listGroupedGroup`, params)
    },

    /**
     * 列出权限树
     * @param params
     *  code
     *  unitId
     */
    getGroupTree(unitId) {
        return util.ajax(`${base}/api/org/getGroupTree`, unitId)
    },

    /**
     * 列出单位树
     * @param parentId
     */
    getUnitTree(parentId) {
        return util.ajax(`${base}/api/org/getUnitTree`, parentId);
    },
    getUnitById(id) {
        return util.ajax(`${base}/api/org/getUnitById`, id)
    },
    clearUserbindIp(userids) {
        return util.ajax(`${base}/api/org/clearUserbindIp`, userids);
    },
    getPYIndexStr(name) {
        return util.ajax(`${base}/api/org/getPYIndexStr`, name);
    },
    getLoginUserUnitDepartments() {
        return util.ajax(`${base}/api/org/getLoginUserUnitDepartments`)
    },

    getCurrent(params) {
        return util.ajax(`${base}/api/orgsel/getCurrent`, params)
    },

    orderDepartmentUsers(departmentId) {
        return util.ajax(`${base}/api/org/orderDepartmentUsers`, departmentId)
    },

    orderUsers(userSns, departmentId) {
        return util.ajax(`${base}/api/org/orderUsers`, userSns, departmentId)
    },

    orderUserTop(userId, departmentId) {
        return util.ajax(`${base}/api/org/orderUserTop`, userId, departmentId)
    },

    orderUserLow(userId, departmentId) {
        return util.ajax(`${base}/api/org/orderUserLow`, userId, departmentId)
    },

    orderDepartments(departmentSns) {
        return util.ajax(`${base}/api/org/orderDepartments`, departmentSns)
    },
    listGroupDataByType(params) {
        return util.ajax(`${base}/api/org/listGroupDataByType`, params);
    },
    rebuildPermissionIndex() {
        return util.ajax(`${base}/api/org/rebuildPermissionIndex`);
    }


}


// WEBPACK FOOTER //
// ./src/common/api/org.js